import { getFrameCountInLevel } from 'a/directorsCut/redux/selectors/curriculumSelectors';
import { GAME_ID, REDUX_ACTIONS, GAME_MODES, ITEMS_PER_ROUND } from '../../data/constants';

const initState = {
  // Curriculum Pointers
  levelIndex: 0,
  frameIndex: 0,
  onboardingPhaseIndex: 0,
  gameMode: GAME_MODES.STANDARD,

  isBackButtonVisible: true,
  isCorrectSelection: false,
  isPopcornShowing: false,
  isDirectorVisible: false,
  attemptCount: 0,
  correctAnswerCount: 0,
  prevCorrectCount: 0,
  isRoundFromIntermediateSave: false,
  isWrongItemsTomatoing: false,
  isTryAgainVisible: false,
  hasViewedEntireStoryThisFrame: false,
  associatedEmotionId: '',
  records: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
        isCorrectSelection: false,
      };

    case REDUX_ACTIONS.SET_FRAME_INDEX:
      return {
        ...state,
        frameIndex: payload,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND: {
      const prevCorrectCount = payload.correctAnswerCount || 0;
      return {
        ...state,
        isBackButtonVisible: true,
        frameIndex: 0,
        onboardingPhaseIndex: 0,
        isCorrectSelection: false,
        gameMode: GAME_MODES.STANDARD,
        attemptCount: 0,
        correctAnswerCount: prevCorrectCount,
        prevCorrectCount,
        isRoundFromIntermediateSave: payload.isRoundFromIntermediateSave,
        isPopcornShowing: false,
        isDirectorVisible: false,
        isWrongItemsTomatoing: false,
        hasViewedEntireStoryThisFrame: false,
        records: payload.records,
      };
    }

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        gameMode: GAME_MODES.STANDARD,
        frameIndex: Math.min(state.frameIndex + 1, getFrameCountInLevel(state.levelIndex) - 1),
        attemptCount: 0,
        isDirectorVisible: false,
        isCorrectSelection: false,
        isWrongItemsTomatoing: false,
        hasViewedEntireStoryThisFrame: false,
      };

    case REDUX_ACTIONS.SET_GAME_MODE:
      return {
        ...state,
        hasViewedEntireStoryThisFrame: payload === GAME_MODES.STANDARD
          ? false
          : state.hasViewedEntireStoryThisFrame,
        gameMode: payload,
      };

    case REDUX_ACTIONS.SET_IS_POPCORN_SHOWING:
      return {
        ...state,
        isPopcornShowing: payload,
      };

    case REDUX_ACTIONS.SET_IS_DIRECTOR_VISIBLE:
      return {
        ...state,
        isDirectorVisible: payload,
      };

    case REDUX_ACTIONS.INCREASE_CORRECT_ANSWERS_COUNT:
      return {
        ...state,
        correctAnswerCount: state.correctAnswerCount + 1,
      };
    case REDUX_ACTIONS.SELECT_RESPONSE: {
      const { isCorrectSelection, attemptCount } = payload;
      const gameMode = isCorrectSelection ? GAME_MODES.FEEDBACK_POSITIVE : GAME_MODES.FEEDBACK_NEGATIVE;
      return {
        ...state,
        gameMode,
        attemptCount,
        isCorrectSelection,
      };
    }

    case REDUX_ACTIONS.SET_IS_WRONG_ITEMS_TOMATOING:
      return {
        ...state,
        isWrongItemsTomatoing: payload,
      };

    case REDUX_ACTIONS.SET_IS_TRY_AGAIN_VISIBLE:
      return {
        ...state,
        isTryAgainVisible: payload,
      };

    case REDUX_ACTIONS.SET_ONBOARDING_PHASE_INDEX:
      return {
        ...state,
        onboardingPhaseIndex: state.onboardingPhaseIndex + 1,
      };

    case REDUX_ACTIONS.ROUND_END:
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        onboardingPhaseIndex: 0,
        hasViewedEntireStoryThisFrame: false,
      };

    case REDUX_ACTIONS.SET_HAS_VIEWED_ENTIRE_STORY_THIS_FRAME:
      return {
        ...state,
        hasViewedEntireStoryThisFrame: true,
      };

    case REDUX_ACTIONS.SET_ASSOCIATED_EMOTION_ID:
      return {
        ...state,
        associatedEmotionId: payload.id,
      };

    case REDUX_ACTIONS.QUICK_PASS: {
      const correct = payload ? ITEMS_PER_ROUND : 0;
      return {
        ...state,
        correctAnswerCount: correct,
      };
    }

    case REDUX_ACTIONS.HIDE_BACK_BUTTON:
      return { ...state, isBackButtonVisible: false };

    case REDUX_ACTIONS.UPDATE_RECORDS:
      return {
        ...state,
        records: [...state.records, payload],
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
